import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
$("header .nav ul li").eq(0).addClass("active");
$("header").removeClass("head1");

$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})


// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
	delay: 5000,
	disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
        el: ".banner .swiper-pagination",
        clickable: true,
    },
    // 其他配置...
    on: {
        slideChange: function() {
            this.slides.forEach(function (slideEl, index) {
                if (index === 3) { // 索引从0开始，所以第三张是索引2
                    slideEl.classList.add('active');
                } else {
                    slideEl.classList.remove('active');
                }
            });
        }
    }
});



 var swiper = new Swiper(".product-list .swiper1", {
    navigation: {
      nextEl: ".btn1 .swiper-button-next",
      prevEl: ".btn1 .swiper-button-prev",
    },
     breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.813%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: '1.813%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
 var swiper = new Swiper(".product-list .swiper2", {
    navigation: {
      nextEl: ".btn2 .swiper-button-next",
      prevEl: ".btn2 .swiper-button-prev",
    },
     breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.813%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: '1.813%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
 var swiper = new Swiper(".product-list .swiper3", {
    navigation: {
      nextEl: ".btn3 .swiper-button-next",
      prevEl: ".btn3 .swiper-button-prev",
    },
     breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: '1.813%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: '1.813%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});


$(".product-nav .tab-link").eq(0).addClass("active");
$(".swiper-btn .btn").eq(0).addClass("active");
$(".product-list .swiper").eq(0).addClass("active");
$(".product-nav .tab-link").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".swiper-btn .btn").eq(index).addClass("active").siblings().removeClass("active");
    $(".product-list .swiper").eq(index).addClass("active").siblings().removeClass("active");
})


$(".section2 ul li").hover(function() {
    $(this).addClass("active2").siblings().addClass("active1");
},function() {
    $(".section2 ul li").removeClass("active1");
    $(".section2 ul li").removeClass("active2");
})
// 数字滚动
var wrapTop = $(".index .section1").height() 
console.log(wrapTop);

var istrue = true;
var s = $(window).scrollTop();
if (s > wrapTop - 70 && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > wrapTop  - 70  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

 var praise = new Swiper(".section7 .mySwiper", {
    navigation: {
        nextEl: ".section7 .swiper-button-next",
        prevEl: ".section7 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
       spaceBetween: '3.03%',
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
      }
    } 
});

var news = new Swiper(".section8 .mySwiper", {
    navigation: {
        nextEl: ".section8 .swiper-button-next",
        prevEl: ".section8 .swiper-button-prev",
    },
    breakpoints: {
      768: {  //当屏幕宽度小于等于768
       spaceBetween: '1.82%',
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
      }
    } 
});

